import React from 'react';

const Pages: React.FC = () => {
    return (
        <div>
            <h1>Pages</h1>
            <p>Welcome to the Pages component!</p>
        </div>
    );
};

export default Pages;